import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans'

//starting with capital letter will ensure this is treated as a component
const BomGridItemH = ({col}) => {

    return (
        <div className="uiSearchSubList">
            <span className="sItemID uiCenter"><SarasTrans value="BOM Name" /></span>
            <span className="sBomWeight uiCenter"><SarasTrans value="Material" /></span>
            <span className="sBomWeight uiCenter"><SarasTrans value="Process" /></span>
            <span className="sBomWeight uiCenter"><SarasTrans value="Total" /></span>
        </div>
    );
}

export default BomGridItemH
